import { render, staticRenderFns } from "./TemplateWidgetInfoDialog.vue?vue&type=template&id=8defcf4c&scoped=true"
import script from "./TemplateWidgetInfoDialog.vue?vue&type=script&lang=js"
export * from "./TemplateWidgetInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./TemplateWidgetInfoDialog.vue?vue&type=style&index=0&id=8defcf4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8defcf4c",
  null
  
)

export default component.exports